import { Link, Navigate, useSearchParams } from "react-router-dom";
import { languages, useScenes } from "@/lib/scenes";
import AppHeader from "@/components/AppHeader";

export default function ScenesPage() {
  const [params] = useSearchParams();
  const lang = params.get("lang") ?? "";
  const langs = languages as Record<string, { label: string; locale: string }>;
  const scenes = useScenes();

  if (!lang || !langs[lang]) return <Navigate to="/landing" replace />;

  return (
    <div className="page-shell">
      <AppHeader />
      <main className="landing">
        <section className="landing-hero">
          <p className="eyebrow">Prototype</p>
          <h1>Pick a scene to explore.</h1>
          <p className="lede">You are learning {langs[lang].label}. Choose a scene to begin.</p>
        </section>

        <section className="landing-panel">
          <div className="landing-header">
            <div>
              <p className="section-label">Step 2</p>
              <h2>Which scene should we start with?</h2>
            </div>
            <Link className="ghost-link" to="/landing">
              Change language
            </Link>
          </div>

          <div className="scene-grid">
            {(scenes ?? []).map((scene) => {
              const imageSrc = scene.previewImage ?? scene.image;
              return (
                <Link
                  key={scene.slug}
                  to={`/lesson?scene=${scene.slug}&lang=${lang}`}
                  className="scene-choice-card"
                >
                  <img
                    className="scene-choice-image"
                    src={imageSrc}
                    alt={scene.alt}
                    width={scene.width}
                    height={scene.height}
                    loading="lazy"
                    decoding="async"
                    style={{ aspectRatio: `${scene.width} / ${scene.height}` }}
                  />
                  <div className="scene-choice-copy">
                    <p className="section-label">{scene.label}</p>
                    <h2>{scene.title}</h2>
                    <p>{scene.itemCount} words to explore</p>
                    <span className="scene-choice-cta">Start lesson →</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>
      </main>
    </div>
  );
}
